import { Navigate, useLocation } from 'react-router-dom';

/**
 * Deliberate fallback for language-prefixed public links (/ar/..., /es/...)
 * while no localized public page exists for them, or the language is not
 * released. Replaces (not pushes) to the English equivalent, keeping the
 * query string (aff, UTMs) and hash, so the address and displayed language
 * always agree. Phase 2 replaces this with real localized routes for
 * available languages; disabled languages keep this behavior.
 */
export function LocalizedPrefixRedirect() {
  const { pathname, search, hash } = useLocation();
  const rest = pathname.replace(/^\/(ar|es|en)(?=\/|$)/, '') || '/';
  return <Navigate to={`${rest}${search}${hash}`} replace />;
}
